import SalesOrdersOverview from './SalesOrdersOverview';

export const page = {
    title: 'salesorders.title',
    path: '/sales-orders',
    icon: 'receipt',
    component: SalesOrdersOverview
}
